// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 805 ? "25f4ac2a" : chunkId) + "." + {"448":"ee9b86c9166d09ef","629":"5f8c96fead29b6c9","644":"47168a4e65c9c513","805":"0de419754430e75e","816":"11c2b19af0571f5b"}[chunkId] + ".js";
};